<app-loader *ngIf="loader"></app-loader>
<div style="padding: 10% 10% 10% 38%;">
    <p style="padding-left: 15%;">Processing....</p>
    <h4>Please do not refresh page</h4>
</div>